const AdminPanel = () => {
  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-4">Admin Panel</h1>
      <p>Welcome to the Admin Panel. Select an option from the menu.</p>
    </div>
  );
};

export default AdminPanel;
